module.exports = __webpack_public_path__ + "img/InsiderThreat.a870fd82.jpg";